import { tv } from 'tailwind-variants'

import { body1, body2, h5 } from '@ui-kit/core/typography'

export const lineListContainer = tv({
  slots: {
    container: 'flex flex-col',
    dataContainer: 'flex flex-col gap-y-2.5',
  },
})

export const lineListItem = tv({
  slots: {
    mainItem: 'flex flex-row items-center justify-between',
    label: 'flex-1',
    rightGroup: 'flex flex-1 flex-row items-center justify-end gap-x-1',
    value: '',
    subItemsList: 'gap-y-2.5 pl-2.5 pt-0',
    subItem: body2({ emphasis: 'medium' }),
  },
  variants: {
    labelVariant: {
      body2: {
        label: body2(),
        value: body2({ className: 'text-right' }),
      },
      h5: {
        label: h5(),
        value: h5({ className: 'text-right' }),
      },
    },
    isBold: {
      false: {},
    },
    isValueBody1: {
      true: {
        value: body1({ className: 'text-right' }),
      },
    },
  },
  compoundVariants: [
    {
      labelVariant: 'body2',
      isBold: true,
      className: {
        label: 'font-modern-era-medium',
        value: 'font-modern-era-medium',
      },
    },
    {
      isValueBody1: true,
      isBold: true,
      className: {
        value: 'font-modern-era-medium',
      },
    },
  ],
  defaultVariants: {
    isBold: false,
    labelVariant: 'body2',
    isValueBody1: false,
  },
})
